import { atom } from "recoil";
import { atomWithPersistence } from "../utils/persistence";
import { FilmId, FilmPart } from "../components/help/helpFilms";

/** The help film playing now: which one, from which part, and where it was opened (for analytics). */
export type FilmRequest = { film: FilmId; part: FilmPart; place: string };

export const helpFilmPlayingState = atom<FilmRequest | undefined>({
    key: "help.film.playing",
    default: undefined,
});

/** Parts of films this person has watched (`film:from` → when), so their links can shrink to the length. */
export const helpFilmsWatchedState = atomWithPersistence<Record<string, number>>("help.watched", {});
